import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import React from 'react';
import {
  FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import { Alert } from 'Packages/FacetDesign/Components/Alert';
import { dataAttrs } from 'Helpers/Testing';

const SetNewPassword = ({
  resource, onSubmit, errors, saving,
}) => {
  const passwordsMatch = resource.attr('newPassword') === resource.attr('confirmPassword');

  const isSubmitDisabled = !resource.isValid() || !passwordsMatch;
  const shouldShowErrors = errors.length > 0;

  return (
    <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
      <FDStack direction={'column'} spacing={2}>
        <MetaControlField
          attr={'title'}
          data-test={`user-auth-setup-title-${resource.type()}`}
        />
        <MetaControlField attr={'description'} />
      </FDStack>
      <FDStack direction={'column'} alignItems={'stretch'} spacing={2} flex={1}>
        <MetaControlField
          attr={'newPassword'}
          data-test={'user-auth-setup-password-input'}
          flex={1}
        />
        <MetaControlField
          attr={'confirmPassword'}
          data-test={'user-auth-setup-confirm-password-input'}
          flex={1}
        />
      </FDStack>
      <FDStack direction={'column'} alignItems={'center'} spacing={2}>
        {resource.isValid() && passwordsMatch && !shouldShowErrors ? <Alert
          status="success"
          title="Passwords match"
        /> : null}
        {shouldShowErrors
          ? <Alert
            status={'error'}
            title={'Errors occurred while saving your password'}
            details={errors.map((e) => e.detail)}
          />
          : null}
        <FDPrimaryActionButton
          {...dataAttrs('user-auth-setup-create-password-submit-button')}
          loading={saving}
          onClick={onSubmit}
          disabled={isSubmitDisabled}
          label="Submit"
          test={'user-auth-setup-create-password-submit-button'}
        />
        <Alert description={resource.attr('infoDescription')} title={resource.attr('infoTitle')} status={'info'} />
      </FDStack>
    </FDStack>
  );
};

SetNewPassword.propTypes = {
  resource: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  errors: PropTypes.array,
  saving: PropTypes.bool,
};

SetNewPassword.defaultProps = {
  errors: [],
  saving: false,
};

export default SetNewPassword;
